import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';
import { Section, SectionLink, SectionName } from '../components/Chrome';
import Icon from '../components/Icon';

const SettingsDataPage = () => (
  <>
    <Helmet>
      <title>Data</title>
    </Helmet>
    <Section>
      <SectionName isSecondLevel>Data</SectionName>
      <SectionLink to="delete-account">
        Delete account
        <Icon name="arrow-right" />
      </SectionLink>
    </Section>
    <Outlet />
  </>
);

export default SettingsDataPage;
